import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ContractItemWrapper } from './ContractItem.style';

const ContractItem = ({ filename, onItemClick, id, importedAt, uploadedBy, contractIndex }) => {
    let toolTipText = '';
    if (filename && filename.length > 45) {
        toolTipText = filename;
    }

    return (
        <ContractItemWrapper
            id={contractIndex}
            data-tip={toolTipText}
            data-class="tooltip"
            onClick={event =>
                onItemClick(event, { id, importedAt, uploadedBy, filename, contractIndex })
            }
            data-testid={`contract_${contractIndex}`}
            data-for={`tooltip_${contractIndex}`}
        >
            {filename}
            <ReactTooltip id={`tooltip_${contractIndex}`} />
        </ContractItemWrapper>
    );
};

export default React.memo(ContractItem);
